import React from "react";
import OurWork from "../features/ourWork/OurWork";
import AnimateSection from "../features/animateSection/AnimateSection";

export default function OurWorkPage({setModalOpen, modalOpen}) {

    return (
        <AnimateSection>
            <OurWork setModalOpen={setModalOpen} modalOpen={modalOpen} />
        </AnimateSection>
    )
}